module.exports = __webpack_public_path__ + "img/palette-capture_en.dc3fe3b.jpg";